import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import avatar from '../../Pics/avatar.jpg'

import SpecificComponent from '../SpecificComponent'
import { Fab, FormControl, InputLabel, Select, MenuItem, Input, Grid, Checkbox } from '@material-ui/core';
import Utils from '../../providers/Utils';
import PropTypes from 'prop-types';
import Ws from '../../providers/Ws';


export default class OpenAddCV extends SpecificComponent {

    constructor(props) {
        super(props)
        this.state = {

        }
    }

    //fisaPost adresaMedia + /Angajati/FisePost








    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.dialogClose}
                fullWidth={true}
                maxWidth={'sm'}
                style={{
                    zIndex: 6000,
                }}
            >

                <DialogActions>
                    <Fab style={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none'
                    }} onClick={this.props.dialogClose} className="pm-round-button-dialog">
                        <i style={{ color: 'black', fontSize: 30 }} className='material-icons pm-round-button-text-dialog'>clear</i>
                    </Fab>
                </DialogActions>
                <div className='fix-line'></div>
                <div
                    style={{
                        right: 0,
                        left: 0
                    }}
                    className='pm-fisa-postului-container'


                >

                    <div

                        onClick={() => { this.props.selectFile('CV-file') }}
                        className='pm-fisa-buttons'>
                        <span>{this.props.limba.organigrama.adaugaCv} </span>
                        <i className='material-icons' style={{
                            verticalAlign: 'bottom',
                            color: '#0091ff'
                        }}>publish</i>
                    </div>

                    <div
                        onClick={this.props.openCV} style={{ marginLeft: 10 }} className='pm-fisa-buttons'>
                        <span>{this.props.limba.organigrama.veziCv} </span>
                        <i className='material-icons' style={{
                            verticalAlign: 'bottom',
                            color: '#d8a817'
                        }}>book</i>
                    </div>



                </div>


            </Dialog>
        );
    }


}  // end class

